var TESNAV = TESNAV || {};

//TES.apiUrls is compiled in footer.hbs

TESNAV.urlData = {
  "myResources": "/my-resources/downloads",
  "balance": "/my-resources/buyer-dashboard",
  "sellerTier": "/my-resources/seller-tier",
  "myUploads": "/my-resources/uploads",
  "authorDashboard": "/teaching-resources/dashboard?dashType=new",
  "myDownloads": "/my-resources/downloads",
  "myShop": "/teaching-resources/shop/myshop",
  "addResource": "/teaching-resource/upload",
  "createBundle": "/teaching-resources/bundler",
  "manageSales": "/teaching-resources/sales-tool",
  "talentBank": "/jobs/talentbank.aspx",
  "myJobs": "/jobs/myjobs/savedjobs",
  "myCareerProfile": "/member/[[username]]/career-profile",
  "myJobSearches": "/jobs/myjobs/savedsearches",
  "myCourses": "/mycourses/",
  "myForums": "/watched/forums",
  "myFollowers": "/member/[[username]]/followers",
  "myFollowing": "/member/[[username]]/following",
  "myThreads": "/watched/threads",
  "myConversations": "/conversations",
  "account": "/authn/account",
  "profile": "/member/[[username]]",
  "products": "/member/[[username]]/subscriptions",
  "preferenceCentre": "/authn/preference-centre",
  "logout": "/api/authn/sign-out-redirect"
};

TESNAV.extendData = function(data) {
  TESNAV.urlData.myCommunity = data.communityHost;
  TESNAV.urlData.myForums = data.communityHost + TESNAV.urlData.myForums;
  TESNAV.urlData.myThreads = data.communityHost + TESNAV.urlData.myThreads;
  TESNAV.urlData.myConversations = data.communityHost + TESNAV.urlData.myConversations;
  TESNAV.urlData.myFollowers = TESNAV.urlData.myFollowers.replace('[[username]]', data.username);
  TESNAV.urlData.myFollowing = TESNAV.urlData.myFollowing.replace('[[username]]', data.username);
  TESNAV.urlData.profile = TESNAV.urlData.profile.replace('[[username]]', data.username);
  TESNAV.urlData.products = TESNAV.urlData.products.replace('[[username]]', data.username);
  TESNAV.urlData.myCareerProfile = TESNAV.urlData.myCareerProfile.replace('[[username]]', data.username);
  jQuery.extend(data, TESNAV.urlData);
  return data;
};

TESNAV.requestProfile = function(options) {

  if ((typeof Cookies !== 'undefined') && !Cookies.get('TESCookieUser')) {
    TESNAV.$container.find('.js-profile').addClass('loaded');
    return;
  }

  // Looks like community.tes.com has it's own profile div thingy.
  if (window.location.hostname.match(/community\.tes\.com/)) {
    return;
  }

  function requestBalance () {
    jQuery.ajax({url: '/api/payments/balance/v2/global/buyer', cache: false, dataType: 'json'})
      .then(function (balanceData) {
        var balance;
        var siteCountry = Cookies.get('siteCountry').toLowerCase();

        if (balanceData && siteCountry && balanceData[siteCountry] && balanceData[siteCountry].buyer && balanceData[siteCountry].buyer.balance) {
          balance = balanceData[siteCountry].currency.symbol + balanceData[siteCountry].buyer.balance.toFixed(2);
          if (balance) {
            TESNAV.$container.find('.js-balance').text(balance);
          }
        }
      });
    jQuery.ajax({url: '/api/tier/me', cache: false, dataType: 'json'})
      .then(function (tierData) {
        if (tierData && tierData.tier && tierData.tier.name) {
          var tierElement = TESNAV.$container.find('.js-seller-tier');
          tierElement.text(tierData.tier.name);
          switch (tierData.tier.name) {
            case "New Author":
              tierElement.css({"background-color": "#d2d6d9", "color": "#5c656e"});
              break;
            case "Bronze":
              tierElement.css({"background-color": "#5c656e", "color": "#fe864c"});
              break;
            case "Silver":
              tierElement.css({"background-color": "#5c656e", "color": "#ebebeb"});
              break;
            case "Gold":
              tierElement.css({"background-color": "#5c656e", "color": "#ffdb44"});
              break;
          }
        }
      });
  }

  function decodeCookie () {
    var cookie = window.Cookies.get('TESCookieV2');
    cookie = cookie.split('.')[1];
    return (typeof atob !== 'undefined') ? atob(cookie) : Base64.decode(cookie);
  }

  function mySchools () {
    try {
      var orgId = '';
      var orgCount = 0;
      var orgAgentCount = 0;
      var decoded = decodeCookie();
      var orgRoles = JSON.parse(decoded).cache.orgRoles;
      jQuery.each(orgRoles, function(key, val) {
        if ((val.indexOf('orgadmin') > -1) || (val.indexOf('orgrecruiter') > -1)) {
          orgCount = orgCount + 1;
        } else if ((val.indexOf('orgagent') > -1)) {
          orgAgentCount = orgAgentCount + 1;
        }
        return orgId = key;
      });
    } catch(err) {}
    return {
      orgId: orgId,
      multipleOrgsAdmin: orgCount >= 1,      // temporary fix for https://github.com/tes/H2O/issues/820
      multipleOrgsAgent: orgAgentCount >= 1, // don't go right to a single school or give singular text
    };
  }

  //fallback for jobs and other sites where its useless to update footer.xml in .net code for now
  var profileApiUrl = (window.TES && window.TES.apiUrls) ? window.TES.apiUrls.profile : "/api/v1/member";

  function isUserAdmin() {
    try {
      var decoded = decodeCookie();
      var roles = JSON.parse(decoded).cache.roles;
      return !!(~roles.indexOf('resourceadminuser') || ~roles.indexOf('systemadministrator'));
    } catch (e) {
      return false;
    }
  }

  var $profile = TESNAV.$container.find('.js-profile');

  function renderAvatar(data) {
    var profile;
    try {
      if (data == null) return;

      data = TESNAV.extendData(data);
      // add cache busting to the url as the service isn't doing it anymore.
      if (data.avatarSmall) {
        data.avatarSmall = data.avatarSmall + '?_=' + new Date().getTime();
      }
      var siteCountry;
      if (window.Cookies) {
        siteCountry = window.Cookies.get('siteCountry').toLowerCase();
      }
      if (!siteCountry) {
        siteCountry = 'gb';
      }
      /* add My schools link if the user is an org admin for a school */
      var orgData = mySchools(data);
      data.isGB = siteCountry === 'gb';
      data.orgId = orgData.orgId;
      data.multipleOrgsAdmin = orgData.multipleOrgsAdmin;
      data.multipleOrgsAgent = orgData.multipleOrgsAgent;

      profile = TES.templates['header-avatar'](data);
      $profile.html(profile);

      $profile.one('click', requestBalance);

      var alreadyLoaded = false;
      $profile.one('click mouseover', function (evt) {
        if (alreadyLoaded) return;
        alreadyLoaded = true;
        jQuery.ajax({url: profileApiUrl, data: { expand: 'subscriptions' }, cache: false, dataType: 'json', xhrFields: { withCredentials: true }})
          .done(function(data) {
            renderBubble(data, siteCountry);
          });
      });

      TESNAV.notifications();
    } catch (e) {
      if(window.console && window.console.log) console.log(e);
    }
  }

  function renderBubble(data, siteCountry) {
    var profile;
    try {
      if (data == null) return;

      jQuery.extend(data, TESNAV.urlData, { subscriptions: data.subscriptions });

      // add cache busting to the url as the service isn't doing it anymore.
      if (data.avatarSmall) {
        data.avatarSmall = data.avatarSmall + '?_=' + new Date().getTime();
      }
      if (data.avatarLarge) {
        data.avatarLarge = data.avatarLarge + '?_=' + new Date().getTime();
      }
      data.isAdmin = isUserAdmin();

      /* add My schools link if the user is an org admin for a school */
      var orgData = mySchools(data);
      data.orgId = orgData.orgId;
      data.multipleOrgsAdmin = orgData.multipleOrgsAdmin;
      data.multipleOrgsAgent = orgData.multipleOrgsAgent;

      profile = TES.templates['header-profile-v3-' + siteCountry](data);
      $profile.find('.js-profile-panel').html(profile);
      $profile.addClass('js-panel-loaded');
      //Save it globally and fire event so any app can use this data
      // apparently it is not used anymore, but it doesn't hurt leaving it here
      TES.loggedInData = data;
      jQuery('body').trigger('memberDataLoaded');

    } catch (e) {
      if(window.console && window.console.log) console.log(e);
    }

  }
  // get login status / profile information
  jQuery.ajax({url: profileApiUrl, cache: false, dataType: 'json', xhrFields: { withCredentials: true }})
    .done(renderAvatar)
    .complete(function () {
      TESNAV.$container.find('.js-profile').addClass('loaded');
    });
};
